export default __webpack_public_path__ + "static/media/image_computer-levels.bea30e02.svg";